import { RouteConstant } from "@/util/constant/RouteConstant.ts";
import Error404 from "../../components/pages/Error404.tsx";
import SuccessLogin from "../../components/modal/SucessLogin.tsx";
import ChangePasswordView from "../../views/auth/ChangePassword.tsx";
import SuccessfulSignUp from "../../components/modal/SuccessfulSignUp.tsx";
import SuccessReset from "../../components/modal/SuccessReset.tsx";
import PasswordChanged from "../../components/modal/PasswordChanged.tsx";
import { RouteType } from "@/router/route/index.ts";
import InviteTeamMemberPage from "@/components/pages/InviteTeamMemberPage.tsx";
import InviteView from "@/views/auth/InviteView.tsx";
import { SignUpView } from "@/views/authentication/auth/SignUpView.tsx";
import { ResetPasswordView } from "@/views/authentication/auth/ResetPasswordView.tsx";
import Home from "@/views/home/index.tsx";
import { LoginView } from "@/views/authentication/auth/LoginView.tsx";
import { ForgotPasswordView } from "@/views/authentication/auth/ForgotPasswordView.tsx";
import { OtpView } from "@/views/authentication/auth/OtpView.tsx";
import Terms from "@/views/terms-conditions/index.tsx";
import { ContactUsView } from "@/views/contact-us/index.tsx";

export const authRoute: RouteType[] = [
  {
    path: RouteConstant.auth.home.path,
    name: RouteConstant.auth.home.name,
    component: Home,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.terms.path,
    name: RouteConstant.auth.terms.name,
    component: Terms,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.login.path,
    name: RouteConstant.auth.login.name,
    // component: LoginPage,
    component: LoginView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.contact.path,
    name: RouteConstant.auth.contact.name,
    component: ContactUsView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.signup.path,
    name: RouteConstant.auth.signup.name,
    component: SignUpView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.reset.path,
    name: RouteConstant.auth.reset.name,
    component: ForgotPasswordView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.otp.path,
    name: RouteConstant.auth.otp.name,
    component: OtpView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.invite.path,
    name: RouteConstant.auth.invite.name,
    component: InviteView,
    metadata: { isAuthenticated: false },
  },
  // {
  //     path: RouteConstant.dashboard.account.path,
  //     name: RouteConstant.dashboard.account.name,
  //     component: AccountView,
  //     metadata: {isAuthenticated: true},
  // },
  // {
  //     path: RouteConstant.auth.protected.path,
  //     name: RouteConstant.auth.protected.name,
  //     component: Protected,
  //     metadata: {isAuthenticated: false},
  // },
  {
    path: RouteConstant.auth.success.path,
    name: RouteConstant.auth.success.name,
    component: SuccessLogin,
    metadata: { isAuthenticated: true },
  },
  {
    path: RouteConstant.auth.error.path,
    name: RouteConstant.auth.error.name,
    component: Error404,
    metadata: { isAuthenticated: true },
  },
  {
    path: RouteConstant.auth.successSignup.path,
    name: RouteConstant.auth.successSignup.name,
    component: SuccessfulSignUp,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.successReset.path,
    name: RouteConstant.auth.successReset.name,
    component: SuccessReset,
    metadata: { isAuthenticated: false },
  },
  // {
  //     path: RouteConstant.auth.created.path,
  //     name: RouteConstant.auth.created.name,
  //     component: AccountCreated,
  //     metadata: {isAuthenticated: false},
  // },
  {
    path: RouteConstant.auth.changed.path,
    name: RouteConstant.auth.changed.name,
    component: PasswordChanged,
    metadata: { isAuthenticated: false },
  },

  {
    path: RouteConstant.auth.resetPassword.path,
    name: RouteConstant.auth.resetPassword.name,
    component: ResetPasswordView,
    metadata: { isAuthenticated: false },
  },
  {
    path: RouteConstant.auth.changePassword.path,
    name: RouteConstant.auth.changePassword.name,
    component: ChangePasswordView,
    metadata: { isAuthenticated: true },
  },
  {
    path: RouteConstant.dashboard.inviteTeamMember.path,
    name: RouteConstant.dashboard.inviteTeamMember.name,
    component: InviteTeamMemberPage,
    metadata: { isAuthenticated: true },
  },
];
